<template>
   <div class="bottom">
      <div class="footer">
        <img class="f-logo" src="../assets/img/logo.png" alt="">
        <img class="f-text" src="../assets/img/f-text.png" alt="">
        <div class="conact">
          <p>联系我们</p>
          <p><i class="iconfont icon-dianhua3"></i>400-826-2277</p>
          <p><i class="iconfont icon-shoujijianrong"></i>18958188698</p>
          <p><i class="iconfont icon-youxiang"></i>2881927851@qq.com</p>
          <p><i class="iconfont icon-dingwei1"></i> 浙江省杭州市西湖区翠苑街道古翠路80号浙江科技产业大厦12楼#</p>
        </div>
      </div>
      <div class="copyRight">
        企蜂通信  <br /> {{ copyright }} | 浙ICP备18016616号
      </div>
   </div>
</template>
<script>
// import  Api from '../api/http.js'
import Api from '@api/system'
export default {
  name:'Footer',
  components: {},
  data(){
    return {
      copyright:''
    }
  },
  created(){
    this.getCopyRight()
  },
  methods:{
    getCopyRight(){
      Api.fetchParamsList({}).then((res)=>{
        this.copyright = res.data.data.copyright
      })
    }
  }
}
</script>
<style lang="scss">
  // .bottom{
    // margin-top:70px;
  // }
  .footer{
    padding:25px 17px;
    background:#4286c7;
    text-align:center;
    color:#fff;
    .f-logo{
      width:68px;
      height:68px;
    }
    .f-text{
      width:565px;
      height:26px;
    }
    img{
      display: block;
      margin:0 auto 25px;
    }
    .conact{
      padding-top:25px;
      border-top:1px solid #fff;
      font-size:28px;
      line-height:48px;
      & p:first-child{
        font-size:36px;
        padding-bottom:30px;
      }
      i{margin-right:10px;}
    }
  }
  .copyRight{
    padding:25px 0;
    background:#333333;
    font-size: 24px;
    text-align: center;
    line-height:40px;
    color:#fff;
  }
</style>
